export const converter = {
  highlight: (text: string) => {
    if (!text) return '';

    const highlightColor = '#1C9CFF';

    return text.replaceAll(/\{\{(.*?)\}\}/g, (_, p1) => {
      return `<span style="color:${highlightColor}; font-weight:700">${p1.trim()}</span>`;
    });
  },
  sanitizeHTML: (dirty: string) => {
    if (!dirty) return '';

    return (
      dirty
        .replaceAll(/<(?!span(?=\s|>))[^>]+>/gi, '')
        //* span은 style만 허용 화이트리스트로 재조립한다. 여는 태그를 통째로 다시 쓰지 않으면
        //* style을 가진 span에서 on* 이벤트 핸들러 같은 다른 속성이 그대로 살아남는다.
        .replaceAll(/<span\b[^>]*>/gi, (tag) => {
          const style = tag.match(/\sstyle="([^"]*)"/i)?.[1];

          if (!style) {
            return '<span>';
          }

          const safeStyle = style
            .replaceAll(/expression\s*\([^)]*\)/gi, '')
            .replaceAll(/javascript:/gi, '')
            .replaceAll(/url\s*\([^)]*\)/gi, '');

          return `<span style="${safeStyle}">`;
        })
        .replaceAll(/<(?!\/?span(?:\s|>))/gi, '&lt;')
    );
  },
};
